var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shop_index_adv width_center_1200"},[(false)?_c('el-image',{attrs:{"width":"1200px","src":_vm.adv.adv_image,"alt":"","lazy":""}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }